<template>
  <div id="app">
    <router-view name="first"></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style lang="scss">
.el-message-box {
  width: 600px;
}
.mzindex {
  z-index: 9999 !important;
  position: relative !important;
}
.el-message-box__wrapper {
  z-index: 9999 !important;
}
.searchCondition {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  .searchConditionItem {
    display: flex;
    margin-right: 20px;
    margin-bottom: 20px;
    align-items: center;
    span {
      white-space: nowrap;
    }
    .ant-input-affix-wrapper {
      width: 240px;

      .ant-input {
        width: 100%;
      }
    }
    .ant-input {
      width: 240px;
    }

    .ant-select {
      width: 240px;
    }
    .ant-calendar-picker-input {
      width: 100% !important;
    }
  }

  .searchButton {
    button {
      margin-right: 20px;
      margin-bottom: 20px;
    }
  }
}
</style>
